import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=67d0a734&scoped=true&"
import script from "./ContactFooter.vue?vue&type=script&lang=js&"
export * from "./ContactFooter.vue?vue&type=script&lang=js&"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&id=67d0a734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0a734",
  null
  
)

export default component.exports